// extracted by mini-css-extract-plugin
export default {"midContainer":"Fund_midContainer__iS7rq","LeftContent":"Fund_LeftContent__7GeBA","rcontent":"Fund_rcontent__gfemu","heading":"Fund_heading__Qy0ag","para":"Fund_para__dpU1x"};